<template>
    <div>
        <LimitlessPageHeader></LimitlessPageHeader>

        <div class="content">
            <h1>Välkommen {{ user.name }}</h1>

            <dashboard-calendar></dashboard-calendar>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import DashboardCalendar from '@app/pages/dashboard/partials/DashboardCalendar.vue';
import { mapState } from 'pinia';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    name: 'Dashboard',
    components: {
        LimitlessPageHeader,
        DashboardCalendar,
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
    },
};
</script>
